import { useEffect, useState } from 'react';
import { IMembro } from '@/@types/EstruturaOrganizacional';
import { Loading } from '@/components/shared/Loading';
import { ContainerMembros } from '@/components/shared/ContainerMembros';
import { MembroItem } from '@/components/shared/MembroItem';
import { api } from '@/services/api';

const ComposicaoCSARH = () => {
    const [composicaoCSARH, setComposicaoCSARH] = useState<IMembro[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {

        const getComposicaoCSARH = async () => {
            setIsLoading(true);
            const url = '/feagri/colegiados/orgao/sigla/CSA-RH';

            await api.get(url)
                .then(response => {
                    setComposicaoCSARH(response.data);
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => setIsLoading(false));

        }

        getComposicaoCSARH();

    }, []);

    return (
        <>
            <h1>Composição CSA-RH</h1>

            {isLoading ? (
                <Loading color='primary' />
            ) : (
                <ContainerMembros>
                    {composicaoCSARH.map(representante => {
                        return (
                            <MembroItem key={representante._id} data={{
                                representanteFuncao: representante.funcao.funcaoweb,
                                representanteNome: representante.representante.nome,
                                representanteTitulo: representante.representante.funcao_representante,
                                representanteSubfuncao: representante.subfuncao?.subfuncaoweb,
                                foto: representante.representante.foto
                            }} />
                        );
                    })}
                </ContainerMembros>
            )}
        </>
    );
}

export { ComposicaoCSARH };